import { RequestsStates } from "./enums/requestsStates";
import { dateFilter } from "../filters/date.filter";
import { DateType } from "./types/index";

/**   Данные по операции в истории. */
export class OperationData {
  /**Идентификатор в ДБО. */
  public Id: number = 0;
  /**Состояние операции. */
  public RequestState: RequestsStates = RequestsStates.None;
  /**Алиас договора. */
  public ContractAlias: string = "";
  /**Дата-время операции.*/
  public Date: DateType = new Date();
  /**Описание операции. */
  public Description: string = "";
  /**Причина отказа. */
  public DenialRequest: string = "";
  /**Валюта операции. */
  public Currency: string = "";
  /**Сумма операции. */
  public Sum: number = 0;
  /**Картинка. */
  public Picture: string = "";
  /**Картинка. */
  public BigImage: string = "";
  /**Категория операции. */
  public Category: string = "";
  /**
   * Признак активности типа операции.
   * Разрешено создание шаблона и повтора операции.
   */
  public IsRespondentActive: boolean = false;
  /**Признак операции прямого доступа. */
  public IsRespondentDirect: boolean = false;
  /**Внешний ИД операции. */
  public ReferenceId: string = "";

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {
      this.Id = src.Id ?? 0;
      this.Category = src.CategoryName ?? "";
      this.RequestState = (src.RequestState ?? 0) as RequestsStates;
      this.ContractAlias = src.ContractAlias ?? "";
      this.Date = src.Date;
      this.Description = src.Description ?? "";
      this.DenialRequest = src.DenialRequest ?? "";
      this.Currency = src.Currency ?? "";
      this.Sum = src.Sum ?? 0;
      this.Picture = src.Picture ?? "";
      this.BigImage = src.BigImage ?? "";
      this.IsRespondentActive = src.IsRespondentActive ?? false;
      this.IsRespondentDirect = src.IsRespondentDirect ?? false;
      this.ReferenceId = src.ReferenceId ?? "";
    }
  }
}
